import { atom } from 'jotai';
import { parseValidAccountsRatesProductTypeWithDefault } from './utils';
import { locationSearchParsedAtom } from '../../../../atoms';

export const pathnameRawUrlValidAccountsRatesProductTypeAtom = atom((get) => {
  const { product } = get(locationSearchParsedAtom);
  return parseValidAccountsRatesProductTypeWithDefault(product);
});
